import { render, staticRenderFns } from "./ImageCredit.vue?vue&type=template&id=7c00ef5f&scoped=true"
import script from "./ImageCredit.vue?vue&type=script&lang=js"
export * from "./ImageCredit.vue?vue&type=script&lang=js"
import style0 from "./ImageCredit.vue?vue&type=style&index=0&id=7c00ef5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c00ef5f",
  null
  
)

export default component.exports